import { getAudioContext, getMasterGain } from "./ctx";

/* Everything here is synthesized — no audio files. Sine/triangle only, short
   envelopes, one fixed pentatonic set (A, C#, E, F#, B) so overlapping
   events can never sound wrong against each other. */

const A3 = 220.0;
const CS4 = 277.18;
const E4 = 329.63;
const FS4 = 369.99;
const B4 = 493.88;
const PENTATONIC = [A3, CS4, E4, FS4, B4];

function tone(freq: number, startTime: number, duration: number, type: OscillatorType, peakGain: number): void {
  const ctx = getAudioContext();
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, startTime);
  gain.gain.exponentialRampToValueAtTime(Math.max(0.0001, peakGain), startTime + 0.008);
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
  osc.connect(gain).connect(getMasterGain());
  osc.start(startTime);
  osc.stop(startTime + duration + 0.02);
}

/** 8-14ms click for taps / T0 acknowledgements. */
export function playTick(): void {
  const now = getAudioContext().currentTime;
  tone(900, now, 0.012, "sine", 0.08);
}

/** Ascending 2-note chime — an item cleared (T1). */
export function playCleared(): void {
  const now = getAudioContext().currentTime;
  tone(PENTATONIC[2]!, now, 0.15, "sine", 0.12);
  tone(PENTATONIC[4]!, now + 0.08, 0.22, "sine", 0.12);
}

/** Soft descending pair — an honest "Again". */
export function playAgain(): void {
  const now = getAudioContext().currentTime;
  tone(PENTATONIC[1]!, now, 0.12, "triangle", 0.08);
  tone(PENTATONIC[0]!, now + 0.09, 0.16, "triangle", 0.08);
}

/** Short ping for count-in beats outside the metronome scheduler. */
export function playCountIn(): void {
  const now = getAudioContext().currentTime;
  tone(660, now, 0.06, "sine", 0.1);
}

/** 4-note pentatonic motif — session/PB/plaque moments (T2). */
export function playMotif(): void {
  const now = getAudioContext().currentTime;
  const notes = [PENTATONIC[0]!, PENTATONIC[2]!, PENTATONIC[3]!, PENTATONIC[4]!];
  notes.forEach((freq, i) => tone(freq, now + i * 0.12, 0.3, "sine", 0.1));
}
